import { render, staticRenderFns } from "./address.vue?vue&type=template&id=24048870&"
import script from "./address.vue?vue&type=script&lang=js&"
export * from "./address.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/vercel/workpath0/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24048870')) {
      api.createRecord('24048870', component.options)
    } else {
      api.reload('24048870', component.options)
    }
    module.hot.accept("./address.vue?vue&type=template&id=24048870&", function () {
      api.rerender('24048870', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "srcPC/pages/wallet/conversion/address.vue"
export default component.exports